import { Stack } from "@mui/material";
import { useAtom } from "jotai";
import type { FC } from "react";
import { useDocumentsFeatureOptional } from "web_myplann/Api/Rights/RightsProvider";
import { RecentTimelineItemTypeFilterEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { timelineFilterAtom } from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import { DocumentsFilterRow } from "web_myplann/NotificationCenter/FilterScreen/DocumentsFilterRow";
import { FilterRow } from "web_myplann/NotificationCenter/FilterScreen/FilterRow";
import { FilterSection } from "web_myplann/NotificationCenter/FilterScreen/FilterSection";
import { typeResource } from "web_myplann/NotificationCenter/Utils/filterLabels";
import { isDocumentsOnlyActive } from "web_myplann/NotificationCenter/Utils/isDocumentsOnlyActive";

const TYPE_OPTIONS: RecentTimelineItemTypeFilterEnum[] = [
	RecentTimelineItemTypeFilterEnum.All,
	RecentTimelineItemTypeFilterEnum.Activities,
	RecentTimelineItemTypeFilterEnum.Events,
	RecentTimelineItemTypeFilterEnum.Notifications,
];

export const RecentFilters: FC = () => {
	const { t } = useResource();
	const [filter, setFilter] = useAtom(timelineFilterAtom);
	const hasDocumentsFeature = useDocumentsFeatureOptional();
	const documentsOnly = isDocumentsOnlyActive(
		filter.recentDocumentsOnly,
		hasDocumentsFeature,
	);

	return (
		<Stack data-testid="notification-center-filter-recent">
			<FilterSection
				title={t(Resources.NotificationCenter.FilterScreen.TypeSectionTitle)}
				testIdPrefix="type"
			>
				{TYPE_OPTIONS.map((option, i) => (
					<FilterRow
						key={option}
						label={t(typeResource(option))}
						selected={filter.recentType === option && !documentsOnly}
						onClick={() =>
							setFilter((prev) => ({
								...prev,
								recentType: option,
								recentDocumentsOnly: false,
							}))
						}
						isLast={!hasDocumentsFeature && i === TYPE_OPTIONS.length - 1}
						testId={`notification-center-filter-type-${option}`}
					/>
				))}
				{hasDocumentsFeature ? (
					<DocumentsFilterRow
						selected={documentsOnly}
						onClick={() =>
							setFilter((prev) => ({
								...prev,
								recentType: RecentTimelineItemTypeFilterEnum.All,
								recentDocumentsOnly: true,
							}))
						}
					/>
				) : null}
			</FilterSection>
		</Stack>
	);
};
